import { connect } from 'react-redux';
import { compose } from 'recompose';

import TimesheetDetails from '../../timesheetApprovals/components/TimesheetDetails';
import { queryUserWeeklyTimeEntriesGQL } from '../../timesheetApprovals/graphql/index';
import { dispatchShowCreateEditTimeEntryEditorModal, dispatchShowDeleteTimeEntryEditorModal } from '../../timesheetApprovals/actions';
import { getCurrentSelectedUserId, getCurrentSelectedTimesheetDateString, getSelectTimeEntryDateString } from '../selectors';

const mapStateToProps = (state) => {
  return {
    userId: getCurrentSelectedUserId(state),
    originDate: getCurrentSelectedTimesheetDateString(state),
    timeEntryDate: getSelectTimeEntryDateString(state),
  };
};

const mapDispatchToProps = {
  /* TODO - This is a hack. Notice they are importeed from timesheetApprovals.
  * The timesheetDetails component needs to be refactored to be reusable
  * without spaghetti coding between timesheetApprovals and timesheetNavigator.
  * */
  dispatchShowCreateEditTimeEntryEditorModal,
  dispatchShowDeleteTimeEntryEditorModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


// ORDER MATTERS. If you want redux to put the props in required for queries
// you better withRedux FIRST
const enhance = compose(
  withRedux,
  queryUserWeeklyTimeEntriesGQL,
);

export default enhance(TimesheetDetails);
